import React, { useState, useEffect } from "react";
import "./UserAccountCreation.scss";
import {getExternalAccounts} from "../../../util/API/externalaccounts";
import { useSelector } from "react-redux";
import { assignPhysicalCard, assignExternalCard } from "../../../util/API/cardservices";
import CustomForm from "../../UI/CustomForm/CustomForm";
import { getMastercardDetails } from "../../../util/API/transfer";
import { Typography, Box, List, ListItemButton, ListItemText } from "@mui/material";

function UserAccountCreation({selectedUserData}) {
  const [userAccounts, setUserAccounts] = useState(null);
  const [displayMessage, setDisplayMessage] = useState(false);
  const [cardNo, setCardNo] = useState("");
  const [selectedCard, setSelectedCard] = useState(""); 

  const conditionalFields = {
    cardNumber: (value, watch) => watch("accountType") === "313" || watch("accountType") === "229",
    friendlyName: (value, watch) => watch("accountType") === "313",
    purpose: (value, watch) => watch("accountType") === "313",
    fee: (value, watch) => watch("accountType") === "313",
  };

  // console.log(selectedUserData)

  //get user external accounts
  //outside of useEffect to call when new cards created
  async function getUserAccounts() {
    if (!selectedUserData) return;
    const userid = selectedUserData.User.id;
    try {
      setUserAccounts([]); // Reset state before fetching new data
      const response = await getExternalAccounts(userid);
      let records = response.payload?.record;
  
      // Ensure records is always an array
      if (!Array.isArray(records)) {
        records = [records];
      }
  
      // Deduplicates accounts
      const uniqueRecordsMap = new Map();
  
      records.forEach((record) => {
        const key = `${record.Vuserpi3.cardno}-${record.Vuserpi3.id}`;
        if (!uniqueRecordsMap.has(key)) {
          uniqueRecordsMap.set(key, record);
        }
      });
  
      // Convert the Map back to an array
      const uniqueRecords = Array.from(uniqueRecordsMap.values());
  
      setUserAccounts(uniqueRecords);
    } catch (error) {
      console.error("Error fetching user accounts:", error);
    }
  }
  

  async function getFullCardNumber(piid, kycuser, currcode) {
    const response = await getMastercardDetails(
      piid,
      kycuser,
      currcode
    ).then((response) => {
      if (response.Status === "1") {
        setCardNo(response.payload?.forConsumer.cardnumber);
      }
      else {
        setCardNo(null);
      }
      // console.log(response);
    })
  }

  // const handleClick = async (e) => {
  //   console.log(e)
  //   const account = userAccounts.find((row) => row.Vuserpi3.cardno === e.target.value);
  //   console.log(account)
  //   getFullCardNumber(
  //     account.Vuserpi3.id,
  //     account.Vuserpi3.userid,
  //     account.Vuserpi3.currcode
  //   )
  // }

  const handleClick = async (value) => {
    const account = userAccounts.find((row) => row.Vuserpi3.cardno === value);
    // console.log(account)
    setSelectedCard(value);
    getFullCardNumber(
      account.Vuserpi3.id,
      account.Vuserpi3.userid,
      account.Vuserpi3.currcode
    )
  }

  const currentUser = useSelector(
    (state) => state.usersList.selectedUser
  );
  // console.log(currentUser);

  useEffect(() => {
    // console.log(selectedUserData);
    getUserAccounts();
  }, [selectedUserData]);

  const submitCard = async (data, formData) => {
    // console.log(data);
    let response;
    if (data.accountType === '229') {
      response = await assignPhysicalCard(data.cardNumber, currentUser.User.id, 229);
      // console.log(response);
    } else if (data.accountType === '313' ) {
      response = await assignExternalCard(data.cardNumber, 
        currentUser.User.id, 
        313, 
        data.friendlyName,
        data.purpose,
        data.fee,
        currentUser.Useremailaccount.emailAccount);
      // console.log(response);
    }
    if (response?.callStatus === "1") {
      setDisplayMessage('Card added successfully');
      getUserAccounts();
    } else {
      setDisplayMessage(response.payload?.msg);
    }
    
  }

  return (
    <Box className="user-account-creation-container">
      <Box className="row">
        <Box className="col-7">
          <Typography variant="h5">Add New Account to Customer</Typography>
          <Box className="account-creation-left">
            <CustomForm
              conditionalFields={conditionalFields}
              formName={"newaccount"}
              buttonText={"Submit"}
              onSubmit={submitCard}
              loadingButtonText={"Adding Card ..."}
            />
          </Box>
          {displayMessage &&
            <Box>{displayMessage}</Box>
            }
        </Box>
        <Box className="col-5 account-creation-right">
          <Typography variant="h5">List of User Accounts</Typography>
          <Box
            sx={{
              mt: 2,
              border: "1px solid #ccc",
              borderRadius: "5px",
              overflowY: "auto",
              maxHeight: 200,
              backgroundColor: "white !important",
              background: "white !important",
            }}
          >
            <List>
              {userAccounts &&
                userAccounts.map((row) => (
                  <ListItemButton
                  backgroundColor="white !important"
                    key={row.Vuserpi3.id}
                    value={row.Vuserpi3.cardno}
                    onClick={() => handleClick(row.Vuserpi3.cardno)}
                    selected={selectedCard === row.Vuserpi3.cardno}
                    sx={{
                      height: "35px", 
                      padding: "4px 8px",
                      backgroundColor: "white",
                      background: "white",
                      "&:hover": {
                        backgroundColor: "#f1f1f1 !important",
                      },
                      "&.Mui-selected": {
                        backgroundColor: "#e0e0e0 !important",
                      },
                      "&.Mui-selected:hover": {
                        backgroundColor: "#d5d5d5 !important",
                      },
                    }}
                  >
                    <ListItemText
                      primary={`${row.Vuserpi3.friendlyname} - ${row.Vuserpi3.cardno}`}
                      primaryTypographyProps={{
                        fontSize: "14px",
                      }}
                      sx={{ fontSize: "6px" }}
                    />
                  </ListItemButton>
                ))}
            </List>
          </Box>
            <Box className="selected-card-number-box" sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#f9f9f9' }}>
                <Typography sx={{fontWeight: "bold"}}>Selected Card Number:</Typography> 
                {cardNo ? cardNo : selectedCard ? "Not Available" : "No Card Selected"}
            </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default UserAccountCreation;
